.styledTooltip {
  font-family: var(--font-nort);
}

.unit {
  font-size: 8px;
  line-height: 12px;
  margin-top: 6px;
  margin-left: 5px;
}
